export default "__VITE_ASSET__B0pCZoL2__"